import {API} from "@/utils/api";
import axios from 'axios';

export const namespaced = true;

export const state = () => ({
    projects: [],
});

export const getters = {
    getProjects: state => state.projects
}

export const mutations = {

    setProjects(state, projects) {
        state.projects = projects;
    }
};

export const actions = {
    setProjects({commit}, projects) {
        return new Promise((resolve, reject) => {
            commit('setProjects',projects);

            //resolve(resp)
            //reject(error)
        })
    }

};

